/**
 * Build RTK Query / HTTP list arguments from pagination + serialized filters.
 * Wire protocol (ADR-F004): { page, limit, filters: JSON string, ...extras }
 *
 * @param {{
 *   pageIndex?: number,
 *   pageSize?: number,
 *   filters?: Record<string, unknown>,
 *   extras?: Record<string, unknown>,
 * }} args
 */
export function buildListQueryArgs({
  pageIndex = 0,
  pageSize = 10,
  filters = {},
  extras = {},
} = {}) {
  return {
    page: pageIndex,
    limit: pageSize,
    filters: JSON.stringify(filters ?? {}),
    ...extras,
  };
}
